"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var getters = {
  token: function token(state) {
    return state.user.token;
  }
};
var _default = exports.default = getters;